import React from 'react';
import { Responsive } from '@cian/ui-kit';
import { ImageNone } from '@cian/image-none-component';
import classNames from 'classnames';

import { LinkArea } from '../LinkArea';
import { OfferHeader } from '../OfferHeader';
import { AboutBuilding } from '../AboutBuilding';
import { Undergrounds } from '../Undergrounds';
import { OfferDescription } from '../OfferDescription/OfferDescription';
import { TabletCardControls } from '../TabletCardControls';
import { Favorites } from '../Favorites';
import { Address } from '../Address';
import { PhoneButton } from '../PhoneButton';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../api';
import { IPageState } from '../../types/page';
import { trackCardClick, trackRemoveFromFavorites } from './tracking';
import { trackPhoneButtonClick } from '../Phone/tracking';

import * as styles from './Card.css';

export interface ICardProps {
  favoriteEntity: IFavoriteEntity;
  user: TUser;
  page: IPageState;
  total: number;

  removeFavorite(): void;
}

export const Card: React.FC<ICardProps> = ({ total, favoriteEntity, page, user, removeFavorite }) => {
  const trackMediaClick = React.useCallback(() => {
    trackCardClick('card_photo');
  }, [trackCardClick]);
  const trackTitleClick = React.useCallback(() => {
    trackCardClick('card_header');
  }, [trackCardClick]);
  const trackJKButtonClick = React.useCallback(() => {
    trackCardClick('card_button');
  }, [trackCardClick]);
  const trackShowNumber = React.useCallback(() => {
    const { entityId } = favoriteEntity;
    trackPhoneButtonClick(page, user, entityId, [favoriteEntity], total);
  }, [favoriteEntity, trackPhoneButtonClick]);
  const handleRemove = React.useCallback(() => {
    trackRemoveFromFavorites(favoriteEntity.fullUrl);
    removeFavorite();
  }, [favoriteEntity, trackRemoveFromFavorites, removeFavorite]);

  const { title, fullUrl, photoFullUrl, bargainTerms, jkInfo, geo, description, phone } = favoriteEntity;

  return (
    <div className={styles['card']}>
      <LinkArea className={styles['media']} href={fullUrl} onClick={trackMediaClick}>
        <div className={styles['gallery']}>
          {photoFullUrl ? <img className={styles['image']} src={photoFullUrl} /> : <ImageNone />}
        </div>
      </LinkArea>
      <div className={styles['content']}>
        <LinkArea className={styles['content']} href={fullUrl} preventDefault>
          <div className={styles['header']}>
            {bargainTerms.priceText && <OfferHeader price={bargainTerms.priceText} />}
            <AboutBuilding name={title} buildingInfo={jkInfo?.deadlineText ?? ''} onLinkClick={trackTitleClick} />
            {geo.undergrounds?.length ? <Undergrounds undergrounds={geo.undergrounds} /> : null}
            <Address address={geo.address} />
            {description ? <OfferDescription description={description} /> : null}
          </div>
        </LinkArea>
        {phone && (
          <Responsive phone>
            <div className={classNames(styles['call'])}>
              <PhoneButton phone={phone} />
            </div>
          </Responsive>
        )}
        <div className={styles['controls']}>
          <TabletCardControls
            phone={phone}
            jkInfo={jkInfo}
            fullUrl={fullUrl}
            trackPhoneClick={trackShowNumber}
            trackJKButtonClick={trackJKButtonClick}
          />
          <div className={classNames(styles['favorite'])}>
            <Favorites onClick={handleRemove} />
          </div>
        </div>
      </div>
    </div>
  );
};
